import { render } from "./UsedInventory.vue?vue&type=template&id=65b5a8c2"
import script from "./UsedInventory.vue?vue&type=script&lang=js"
export * from "./UsedInventory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__